
import { Component, Prop, Vue } from "vue-property-decorator";
import LogTable from "@/components/logs/LogTable.vue";

@Component({
  components: { LogTable },
})
export default class BuildingLogsTable extends Vue {

  @Prop({default: null})
  public building: any;

  private logs = {
    rows: [],
    count: 0,
    types: [],
  };
  private loadingLogs: boolean = false;

  private getLogs(params?: any): void {
    if (this.building) {
      this.loadingLogs = true;
      this.$store.dispatch("logs/getLogs", {
        query: {
          currentPage: "building",
          entityId: this.building.id,
          entityType: "building",
          ...params,
        },
      }).then((resLogs) => {
        this.logs.rows = resLogs.rows;
        this.logs.count = resLogs.count;
        this.logs.types = resLogs.types;
      }).finally(() => {
        this.loadingLogs = false;
        this.$emit("loaded");
      });
    }
  }
}
